import React, { useState } from 'react';
import { connect } from 'react-redux';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import Button from '../shared/Button';
import Alert from '../shared/Alert';
import Modal from './Modal';

import { withFirebase } from '../../firebase';

import '../dashboard/dashboard.scss';

const UpdateEmailModal = (props) => {
  const {
    open,
    onClose,
    currentUser,
    firebase,
    onSuccess,
  } = props;

  const {
    firstName,
    lastName,
    email,
  } = currentUser;

  const [newEmail, setNewEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (!!newEmail && !!password) {
        await firebase.updateUserEmail(newEmail, password, firstName, lastName);
        onSuccess(newEmail);
        onClose();
      }
    } catch (err) {
      setError('Something went wrong. Please contact administrator.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setNewEmail('');
        setPassword('');
      }}
      onSubmit={onSubmit}
      title="Update Email"
    >
      <div className="p-lg">
        <div className='secondary m-b-md'>You have to re-enter your current password to change the email</div>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12 }}>
            <div className="p-t-md">
              <TextField
                id="email"
                type="email"
                label="New email"
                value={newEmail}
                onChange={(e) => {
                  setNewEmail(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12 }}>
            <div className="p-t-md">
              <TextField
                id="password"
                type="password"
                label="Current password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
        <div className="actions m-t-lg d-flex flex-end">
          <Button
            text="Submit"
            color="primary"
            onClick={onSubmit}
            disabled={loading || newEmail === email || !newEmail || !password}
            loading={loading}
          />
        </div>
      </div>

      <Alert variant="error" message={error} open={!!error} onClose={() => setError(null)} />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.user?.currentUser,
  };
};

export default connect(mapStateToProps)(withFirebase(UpdateEmailModal));
